export default __webpack_public_path__ + "static/media/vvora.f2d7eae1.jpeg";